import { put, call } from 'redux-saga/effects';
import {
    getScheduleEventSuccessAction,
    getScheduleEventFailureAction,
    postScheduleEventSuccessAction,
    postScheduleEventFailureAction,
    updateScheduleEventDataSuccessAction,
    updateScheduleEventDataFailureAction,
    deleteScheduleEventSuccessAction,
    deleteScheduleEventFailureAction,
    getSlotSummarySuccessAction,
    getSlotSummaryFailureAction,
    updateSlotDataSuccessAction,
    updateSlotDataFailureAction,
    blockSlotForDaySuccessAction,
    blockSlotForDayFailureAction,
    getUnavailabilitySuccessAction,
    getUnavailabilityFailureAction,
    postUnavailabilitySuccessAction,
    postUnavailabilityFailureAction,
    deleteUnavailabilitySuccessAction,
    deleteUnavailabilityFailureAction,
    getAvailabilitySuccessAction,
    getAvailabilityFailureAction,
    postAvailabilitySuccessAction,
    postAvailabilityFailureAction,
    updateAvailabilitySuccessAction,
    updateAvailabilityFailureAction,
    getScheduleEventRequestAction,
    moveBulkAppointmentForSlotSuccessAction,
    moveBulkAppointmentForSlotFailureAction,
    unblockSlotForDaySuccessAction,
    unblockSlotForDayFailureAction,
    cancelBulkAppointmentSuccessAction,
    cancelBulkAppointmentFailureAction,
    getTimelineSuccessAction,
    getTimelineFailureAction,
} from '../actions/scheduleActions';
import { END_POINTS } from '../../api/endpoints';
import { API } from '../../api/api';

export function* getDoctorScheduleEvents() {
    try {
        const baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;

        const eventResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.getScheduleEvents}`
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message);
        }

        yield put(getScheduleEventSuccessAction(eventResponse.data));
    } catch (error) {
        yield put(getScheduleEventFailureAction(error.message));
    }
}

export function* createDoctorScheduleEvents(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const eventResponse = yield call(
            API.post,
            `${baseUrl}${END_POINTS.createScheduleEvents}`,
            {
                ...action.payload.body
            }
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message)
        }
        yield put(postScheduleEventSuccessAction(eventResponse.data));
    } catch (error) {
        yield put(postScheduleEventFailureAction(error.message));
    }
}

export function* updateScheduleEvent(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const eventResponse = yield call(
            API.patch,
            `${baseUrl}${END_POINTS.updateScheduleEvent(action.payload.id)}`,
            {
                ...action.payload.body
            }
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message)
        }
        yield put(updateScheduleEventDataSuccessAction(eventResponse.data));
    } catch (error) {
        yield put(updateScheduleEventDataFailureAction(error.message));
    }
}

export function* deleteScheduleEvent(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const eventResponse = yield call(
            API.delete,
            `${baseUrl}${END_POINTS.deleteScheduleEvent(action.payload.id)}`,
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message)
        }
        yield put(deleteScheduleEventSuccessAction(eventResponse.data));
    } catch (error) {
        yield put(deleteScheduleEventFailureAction(error.message));
    }
}

export function* getDoctorSlotSummary(action) {
    try {
        const baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;

        const { startDate, endDate, hospitalId } = action.payload || {};
        const eventResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.getSlotSummary(startDate, endDate, hospitalId)}`
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message);
        }

        yield put(getSlotSummarySuccessAction(eventResponse.data));
    } catch (error) {
        yield put(getSlotSummaryFailureAction(error.message));
    }
}

export function* updateSlotData(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const eventResponse = yield call(
            API.patch,
            `${baseUrl}${END_POINTS.updateSlot(action.payload.id)}`,
            {
                ...action.payload.body
            }
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message)
        }
        yield put(updateSlotDataSuccessAction(eventResponse.data));
    } catch (error) {
        yield put(updateSlotDataFailureAction(error.message));
    }
}

export function* blockDaySlot(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const eventResponse = yield call(
            API.post,
            `${baseUrl}${END_POINTS.blockEntireDaySlot}`,
            {
                ...action.payload.body
            }
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message)
        }
        yield put(blockSlotForDaySuccessAction(eventResponse.data));
    } catch (error) {
        yield put(blockSlotForDayFailureAction(error.message));
    }
}

export function* getUnavailabilityData() {
    try {
        const baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;

        const eventResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.getUnavailability}`
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message);
        }

        yield put(getUnavailabilitySuccessAction(eventResponse.data));
    } catch (error) {
        yield put(getUnavailabilityFailureAction(error.message));
    }
}

export function* postUnavailabilityData(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const eventResponse = yield call(
            API.post,
            `${baseUrl}${END_POINTS.postUnavailability}`,
            {
                ...action.payload.body
            }
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message)
        }
        yield put(postUnavailabilitySuccessAction(eventResponse.data));
    } catch (error) {
        yield put(postUnavailabilityFailureAction(error.message));
    }
}

export function* deleteUnavailabilityData(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const eventResponse = yield call(
            API.delete,
            `${baseUrl}${END_POINTS.deleteUnavailability(action.payload.id)}`,
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message)
        }
        yield put(deleteUnavailabilitySuccessAction(eventResponse.data));
    } catch (error) {
        yield put(deleteUnavailabilityFailureAction(error.message));
    }
}

export function* getAvailabilityData(action) {
    try {
        const baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;

        const hospitalId = action?.payload?.hospitalId;
        const eventResponse = yield call(
            API.get,
            `${baseUrl}${typeof END_POINTS.getAvailability === 'function' ? END_POINTS.getAvailability(hospitalId) : END_POINTS.getAvailability}`
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message);
        }

        yield put(getAvailabilitySuccessAction(eventResponse.data));
    } catch (error) {
        yield put(getAvailabilityFailureAction(error.message));
    }
}

export function* postAvailabilityData(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const eventResponse = yield call(
            API.post,
            `${baseUrl}${END_POINTS.createAvailability}`,
            {
                ...action.payload.body
            }
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message)
        }
        yield put(postAvailabilitySuccessAction(eventResponse.data));
    } catch (error) {
        yield put(postAvailabilityFailureAction(error.message));
    }
}

export function* updateAvailabilityData(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const eventResponse = yield call(
            API.patch,
            `${baseUrl}${END_POINTS.updateAvailability(action.payload.id)}`,
            {
                ...action.payload.body
            }
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message)
        }
        yield put(updateAvailabilitySuccessAction(eventResponse.data));
    } catch (error) {
        yield put(updateAvailabilityFailureAction(error.message));
    }
}

export function* moveBulkAppointments(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const eventResponse = yield call(
            API.post,
            `${baseUrl}${END_POINTS.moveBulkAppointment(action.payload.body.fromSlotId)}`,
            {
                toSlotId: action.payload.body.toSlotId
            }
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message)
        }
        yield put(moveBulkAppointmentForSlotSuccessAction(eventResponse.data));
    } catch (error) {
        yield put(moveBulkAppointmentForSlotFailureAction(error.message));
    }
}

export function* unblockDaySlot(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const eventResponse = yield call(
            API.post,
            `${baseUrl}${END_POINTS.unblockEntireSlot}`,
            {
                ...action.payload.body
            }
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message)
        }
        yield put(unblockSlotForDaySuccessAction(eventResponse.data));
    } catch (error) {
        yield put(unblockSlotForDayFailureAction(error.message));
    }
}

export function* cancelBulkAppointment(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const eventResponse = yield call(
            API.post,
            `${baseUrl}${END_POINTS.bulkCancel(action.payload.id)}`,
            // The slot bulk-cancel API takes free text only; it is recorded on any refund
            action.payload.reason ? { reason: action.payload.reason } : {},
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message)
        }
        yield put(cancelBulkAppointmentSuccessAction(eventResponse.data));
    } catch (error) {
        yield put(cancelBulkAppointmentFailureAction(error.message));
    }
}

export function* getDoctorTimeline(action) {
    try {
        const baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;

        const hospitalId = action?.payload?.hospitalId;
        const eventResponse = yield call(
            API.get,
            `${baseUrl}${typeof END_POINTS.timeLine === 'function' ? END_POINTS.timeLine(hospitalId) : END_POINTS.timeLine}`
        );

        if (!eventResponse.success) {
            throw new Error(eventResponse.message);
        }

        yield put(getTimelineSuccessAction(eventResponse.data));
    } catch (error) {
        yield put(getTimelineFailureAction(error.message));
    }
}